module.exports = __webpack_public_path__ + "img/asp.d6c3220a.png";